import { App } from "antd"
import { MessageInstance } from "antd/es/message/interface";

let _message: MessageInstance;

const normalizeContent = (content: any) => {
    if (typeof content === 'string') {
        return content;
    }
    if (content?.msg) {
        return content.msg;
    }
    if (content?.message) {
        return content.message;
    }
    if (content instanceof Error) {
        return content.message;
    }
    try {
        return JSON.stringify(content);
    } catch (error) {
        return String(content);
    }
};

const normalizeArgs = (args: any[]) => {
    if (!args.length) {
        return args;
    }
    const [firstArg, ...restArgs] = args;
    if (firstArg && typeof firstArg === 'object' && 'content' in firstArg) {
        return [{ ...firstArg, content: normalizeContent(firstArg.content) }, ...restArgs];
    }
    return [normalizeContent(firstArg), ...restArgs];
};

const createMessageProxy = (message: MessageInstance) => new Proxy(message, {
    get(target, property, receiver) {
        const value = Reflect.get(target, property, receiver);
        if (typeof value !== 'function' || !['open', 'success', 'error', 'info', 'warning', 'loading'].includes(property.toString())) {
            return value;
        }
        return (...args: any[]) => value.apply(target, normalizeArgs(args));
    }
});

const StaticMessage = () =>{
    const { message } = App.useApp();
    _message = createMessageProxy(message);
    return <></>
}

export { _message };

export default StaticMessage;
